module.exports = __webpack_public_path__ + "static/media/cod_burger-mb-en.4de37eea.jpg";